import React from "react";
import "./Legal.scss";

function PrivacyPolicy() {
  return (
    <div className="Legal">
      <h1 className="underline">Privacy Policy</h1>
      <p>
        This website and associated tools, such as subscribing for emails, is
        owned and operated by 8by8 Inc. and we have a firm commitment to your
        privacy and Internet privacy in general. We are committed to protecting
        the privacy of our visitors and users while they interact with the
        content and services on this site (www.app.8by8.us, the “Site”). This
        Privacy Policy applies to the Site and 8by8 owned services only. It does
        not apply to other websites to which we may link. We do gather certain
        types of information about our users, so we want you to understand what
        information we collect about you, how we collect it, how that
        information is used, and how you can control our disclosure of it. You
        agree that your use of the Site signifies your assent to this Privacy
        Policy. If you do not agree with this Privacy Policy, please do not use
        this Site.
      </p>

      <h2>Information collected</h2>
      <p>
        We collect two (2) types of information from you: 1) information that
        you voluntarily supply in form fields on this Site (e.g., sign-up for
        email); and 2) information that may be derived through automated
        tracking mechanisms.
      </p>

      <h2>Voluntary Information for Services and Features</h2>
      <p>
        We collect personally identifiable information when you choose to use
        certain other features of the Site, including a) consenting to receive
        email, and b) participating in any social media interaction as part of
        the Site. When you choose to use these additional features, we may
        require you to provide your “Contact Information” in addition to other
        personal information that may be required to complete a transaction.
      </p>

      <h2>Cookies</h2>
      <p>
        The Site uses “cookies” and other web tracking technologies. Cookies
        enable us to serve secure pages to our users without asking them to sign
        in repeatedly. Most browsers allow you to control cookies, including
        whether or not to accept them and how to remove them. If a user’s system
        is idle for a defined time, the cookie may expire, and if so, forcing
        the user to sign in again to continue their session. This prevents
        unauthorized access to the user’s information while they are away from
        their computer. You may set most browsers to notify you if you receive a
        cookie, or you may choose to block cookies with your browser.
      </p>

      <h2>How We Use Your Information</h2>
      <p>
        8by8 Inc. only uses your personal information for the original purposes
        it was given. 8by8 Inc. will not sell any personal information to third
        parties. Some information on our supporter lists, such as names, email
        addresses, and addresses, may be exchanged with named partners and other
        organizations with principles and/or missions that overlap with those of
        8by8 Inc. Supporters may opt out of such supporter list exchanges at any
        time.
      </p>
      <p>
        Please note that personally identifiable information is used only to
        provide you with a more enjoyable, convenient online experience and to
        help us identify and/or provide information that may be of interest to
        you. We use your personally identifiable information to support and
        enhance your use of the Site and its features, including without
        limitation: tracking email we send to you, and otherwise supporting your
        use of the Site.
      </p>
      <p>
        We may permit certain trusted third parties to track usage, analyze data
        such as the source address that a page request is coming from, your IP
        address or domain name, the date and time of the page request, the
        referring Web site (if any) and other parameters in the URL. This is
        collected in order to better understand our Web site usage, and enhance
        the performance of services to maintain and operate the Site and certain
        features on the Site. We may use third parties to host the Site; operate
        various features available on the Site; send you email; analyze data;
        provide search results and links and assist in fulfilling your orders.
      </p>
      <p>
        8by8 Inc. may disclose Contact Information in special cases where we
        have reason to believe that disclosing this information is necessary to
        identify, contact or bring legal action against someone who may be
        violating our terms and conditions of use or may be causing injury or
        interference with our rights, property, our customers or anyone who
        could be harmed by such activities.
      </p>
      <p>
        We are not liable or responsible for personally identifiable or other
        information you choose to submit on any publicly accessible area of the
        Site.
      </p>
      <p>
        You will receive notice when your personally identifiable information
        might be provided to any third party for any reason other than as set
        forth in this Privacy Policy, and you will have an opportunity to
        request that we not share such information.
      </p>
      <p>
        We use non-identifying and aggregate information to better design the
        Site and for business and administrative purposes. We may also use or
        share with third parties for any purpose aggregated data that contains
        no personally identifiable information.
      </p>

      <h2>Disclaimer to Security</h2>
      <p>
        By consenting to the Privacy Policy, you consent that no data
        transmission over the Internet is completely secure. We cannot guarantee
        or warrant the security of any information you provide to us, and you
        transmit such information to us at your own risk.
      </p>

      <h2>Notification of Changes</h2>
      <p>
        8by8 Inc. reserves the right to change this Privacy Policy from time to
        time at its sole discretion. If at some point in the future, there is a
        change to our Privacy Policy, unless we obtain your express consent,
        such change will only apply to information collected after the revised
        Privacy Policy took effect. Your continued use of the Site indicates
        your assent to the Privacy Policy as posted.
      </p>

      <h2>Contact Information</h2>
      <p>
        If you have any questions or concerns regarding this Privacy Policy,
        please contact us at{" "}
        <a href="mailto: 8by8vote@gmail.com">8by8vote@gmail.com</a>.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
